<template>
  <div class="registration">
    <b-row>
      <b-col sm="12" class="column-left">
        <div class="header">
          <Artist
            :id="artist.id"
            :name="artist.name"
            :handle="artist.handle"
            :place="artist.place"
            :requests="artist.requestsCount"
            :showCounter="$root.isMobile"
            :enableInstaLink="true"
            lg
            class="artist"
          ></Artist>
        </div>
      </b-col>
      <b-col v-if="$root.isDesktop" class="column-separator"></b-col>
      <b-col sm="12" class="column-right">
        <div class="title">
          <h1>
            “Great!
            <br v-if="$root.isMobile"/>
            How can I reach you?”
          </h1>
          <p>Share your email to confirm your request.</p>
        </div>

        <form @submit.prevent>
          <div class="segment email">
            <b-row align-v="center">
              <b-col sm="12" class="column-label"><p class="white my-0">MY EMAIL IS:</p></b-col>
              <b-col sm="12" class="column-form">
                <b-input-group class="mt-3 email">
                  <b-form-input
                    type="text"
                    aria-label="My email is"
                    ref="emailInput"
                    v-model="email"
                    placeholder="My email address"
                    autocomplete="off"
                    autocorrect="off"
                    autocapitalize="none"
                  />
                  <b-input-group-append is-text class="pl-3">
                    <svg svg-inline="" class="icon" @click="resetEmail" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path fill="#969696" d="M7.5 15a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15zm.707-7.5l2.829-2.828-.708-.708L7.5 6.793 4.672 3.964l-.708.708L6.793 7.5l-2.829 2.828.708.708L7.5 8.207l2.828 2.829.708-.708L8.207 7.5z"/></svg>
                  </b-input-group-append>
                </b-input-group>
                <p v-if="showEmailError" class="red mt-2">{{ errors.email }}</p>
              </b-col>
            </b-row>
          </div>

          <div class="segment profile">
            <b-row align-v="center">
              <b-col sm="12" class="column-label"><p class="white my-0">I AM A TATTOO:</p></b-col>
              <b-col sm="12" class="column-form">
                <b-row class="no-pad mt-4 mt-lg-0">
                  <b-col class="text-left">
                    <b-button
                      :variant="profileVariant('Enthusiast')"
                      @click="selectProfile('Enthusiast')"
                    >
                      enthusiast
                    </b-button>
                  </b-col>
                  <b-col class="text-right">
                    <b-button
                      :variant="profileVariant('Artist')"
                      @click="selectProfile('Artist')"
                    >
                      artist
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>

          <div class="segment">
            <b-row>
              <b-col sm="12">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="optin" v-model="optin"/>
                  <label class="custom-control-label" for="optin">
                    I accept to receive updates from Coal
                    <br v-if="$root.isMobile"/>
                    and my requested artist.
                  </label>
                </div>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="12">
                <b-button
                  type="submit"
                  variant="coal-yellow"
                  class="big submit"
                  :disabled="!optin"
                  @click="submit"
                >
                  Confirm
                </b-button>
              </b-col>
            </b-row>
          </div>
        </form>

        <div class="mt-5 errors" v-if="showRequestsError">
          <p class="red">
            You already requested {{ $store.getters.artist.name }} in <br v-if="$root.isMobile"/>
            <span v-html="requestsErrorFormatted"></span>.<br/>
            You cannot request in more than 3 cities or multiple times in the same city.
          </p>
          <p class="yellow-link">
            <a @click="$router.go(-1)">Go back to your selection</a>
          </p>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Artist from '../components/Artist.vue';

const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export default {
  name: 'RegistrationForm',
  components: {
    Artist,
  },
  data() {
    return {
      email: '',
      profile: 'Enthusiast',
      optin: false,
      errors: {
        email: null,
        requests: [],
      },
    };
  },
  computed: {
    showEmailError() {
      return this.errors.email;
    },
    showRequestsError() {
      return this.errors.requests.length > 0;
    },
    requestsErrorFormatted() {
      const join = this.$root.isMobile ? '<br>' : ' ';
      return this.errors.requests.join(`,${join}and `);
    },
    ...mapGetters(['artist']),
  },
  methods: {
    prefill() {
      let user = {};

      if (Object.keys(this.$store.getters.user).length > 0) {
        user = Object.assign({}, this.$store.getters.user);
      }

      if (Object.keys(user).length > 0) {
        this.email = user.email;
        this.profile = user.profile;
      }
    },
    selectProfile(profile) {
      this.profile = profile;
    },
    profileVariant(profile) {
      return profile === this.profile ? 'coal-primary' : 'coal-secondary';
    },
    resetEmail() {
      this.email = '';
      this.$refs.emailInput.focus();
    },
    validateForm() {
      let error = false;

      if (this.email === '') {
        this.errors.email = 'Email address required';
        error = true;
      } else if (!emailRegex.test(this.email)) {
        this.errors.email = 'Wrong email address format';
        error = true;
      }

      return !error;
    },
    validateMaxRequests() {
      return this.checkMaxRequests(this.email).then((response) => {
        let error = false;

        // get all previous requests
        const previousRequests = response.val();

        // check if requestCookie is not undefined
        // if (this.$store.getters.requestCookie !== '') {

        //   if (atob(this.$store.getters.requestCookie) !== this.email) {
            
        //     // translate selectedPlace ids to named place
        //     const citiestmp = this.$store.getters.selectedCities
        //       .map(place => this.$store.getters.place(place));

        //     this.errors.requests = citiestmp;

        //     window.scrollTo(0, window.innerHeight + 300);

        //     throw new Error();
        //   }
        // }

        // if no past requests continue uninterupted
        if (previousRequests === null) {
          return;
        }

        // get all requests for the current artist
        const keys = Object
          .keys(previousRequests)
          .filter(key => previousRequests[key].artistId === this.$store.getters.artist.id);

        // get past requested cities names
        const cities = keys
          .map(key => this.$store.getters.place(previousRequests[key].placeId));


        keys.forEach((key) => {
          // assign each request
          const previousRequest = previousRequests[key];

          this.$store.getters.selectedCities.forEach((placeId) => {
            // check if any of past requested cities is in the selected cities list
            if (previousRequest.placeId === placeId) {
              error = true;
            }
          });
        });

        if (error || cities.length + this.$store.getters.selectedCities.length > 3) {
          // assign past
          this.errors.requests = cities;

          window.scrollTo(0, window.innerHeight + 300);

          throw new Error();
        }
      });
    },
    saveData() {
      const date = new Date();
      const requests = [];

      this.$store.getters.selectedCities.forEach((placeId) => {
        requests.push({
          artistId: this.$store.getters.artist.id,
          placeId,
          email: this.email,
          createdOn: date.getTime(),
        });
      });

      return this.saveRequests({
        artistId: this.$store.getters.artist.id,
        requests,
      });
    },
    submit() {
      if (!this.validateForm()) {
        return false;
      }

      this.validateMaxRequests().then(() => {
        this.$store.commit('user', {
          email: this.email,
          profile: this.profile,
        });

        this.saveData().then(() => {
          this.$store.commit('completed', true);
          this.$store.commit('fromRegistration', false);
          this.$store.commit('requestCookie', this.email);

          this.$router.push({ name: 'confirmation' });
        });
      }).catch(() => {});

      return true;
    },
    ...mapActions(['saveRequests', 'checkMaxRequests']),
  },
  mounted() {
    this.prefill();
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/css/variables';
  .segment {
    margin-top: 50px;
  }

  .icon.selected path {
    fill: $white;
  }

  .profile {
    button {
      width: calc(100% - 8px);
      padding-top: 11px;
      padding-bottom: 11px;
    }
  }

  .input-group {
    border-bottom: 1px solid $grey;
    padding-bottom: 5px;

    .input-group-text {
      padding-left:0px;
      padding-right: 0px;
      background: transparent;
      color: $dark-grey;
      border: 0;
    }

    input, input:-webkit-autofill {
      background: transparent !important;
      border: 0;
      padding-left:2px;
      padding-right: 0px;
      color: $white;

      outline: none;
      box-shadow: none;

      &::placeholder {
        color: #505050;
      }
    }
  }

  .yellow-link {
    color: $yellow;
    text-decoration: underline;
    cursor: pointer;
  }

  .custom-checkbox {
    padding-left: 2.5rem;
    cursor: pointer;

    .custom-control-label::before,
    .custom-control-label::after {
      width: 24px;
      height: 24px;
      transform: translateY(-50%);
      top: 50%;
      left: -2.5rem;
      border-radius: 0;
      border: 0;
    }

    .custom-control-label::before {
      background: transparent url("../assets/svg/checkbox_off.svg") no-repeat 0 0;
    }

    .custom-control-input:checked ~ .custom-control-label::after {
      background: transparent url("../assets/svg/checkbox_on.svg") no-repeat 0 0;
    }

    .custom-control-input ~ .custom-control-label::before,
    .custom-control-input:checked ~ .custom-control-label::before {
      border-color: transparent;
      background-color: transparent;
      box-shadow: none;
    }
  }

  .submit {
    margin-top: 32px;
  }

  .custom-control-label {
    color: #787878;
  }

  .mobile {
    .header {
      background-color: $light-black;
      margin: 0 -$side-margin;
      margin-bottom: 40px;
      padding: 38px 24px 36px 24px;
    }

    .social-right {
      text-align: right;
      color: #787878;
    }
  }

  .desktop {
    .registration {
      margin-top: 20px;
    }

    .no-marg {
      margin: 0;
    }

    .title {
      height: 110px;
      border-bottom: 1px solid #464646;
      margin-bottom: 40px;
    }

    .column-left {
      max-width: 260px;
      padding: 0;
      padding-left: 15px;
    }

    .column-separator {
      max-width: 90px;
    }

    .column-right {
      max-width: 476px;
      padding: 0;
    }

    .order-first {
      max-width: 290px;
      padding: 0;
    }

    .order-last {
      max-width: 290px;
      padding: 0;
    }

    .column-sub-separator {
      max-width: 60px;
    }

    .bordered {
      border: 0;
    }

    .selection {
      margin-top: 80px;
    }

    .column-label {
      max-width: 132px;
      padding: 0;
      margin:0 24px 0 15px;
      font-size: 14.4px;
    }

    .column-form {
      max-width: 320px;
      padding: 0;

      .mt-3.email {
        margin-top: 0px !important;
      }
    }

    .social-left {
      min-width: 100%;
      font-size: 14.4px;

      p {
        margin-bottom: 10px;
      }
    }

    .custom-control-label {
      font-size: 14.4px;
      color: #787878;
    }

    .social-right {
      font-size: 12.8px;
    }

    .submit {
      width: 100%;
      margin-left: 0 !important;
    }
  }
</style>
